import React from 'react';
import { PaperDarkBG, PaperGradientBG } from '../kits';
import UnderlineSketch from './UnderlineSketch';

function SectionA() {
  return (
    <PaperGradientBG>
      <section className="py-16 sm:py-20 md:py-24">
        <div className="container mx-auto text-center px-6 max-w-4xl">
          <h1 className="text-2xl sm:text-3xl md:text-4xl font-mono text-amber-100 mb-6 leading-relaxed">
            DAS EINZIGE WAS SCHLIMMER IST,{" "}
            <span className="text-brand relative inline-block">
              NICHT ANZUFANGEN
              <UnderlineSketch
                className="absolute -bottom-1 left-0 w-full h-2"
                color="zenBrand"
              />
            </span>
            {" "}UM ZU{" "}
            <span className="text-brand relative inline-block">
              SCHEITERN
              <UnderlineSketch
                className="absolute -bottom-1 left-0 w-full h-2"
                color="zenBrand"
              />
            </span>
          </h1>
          <p className="text-sm sm:text-base font-mono text-amber-100 italic mt-4">
            Denis Bitter
          </p>
        </div>
      </section>
    </PaperGradientBG>
  );
}

export default SectionA;